import {
    Box,
    Container,
    Grid,
    Typography,
    Link,
    IconButton,
    Divider,
    Stack
} from '@mui/material';
import {
    Facebook,
    Twitter,
    Instagram,
    LinkedIn,
    Email,
    Phone,
    LocationOn
} from '@mui/icons-material';

const currentYear = new Date().getFullYear();


const Footer = () => {

    return (
        <Box
            component="footer"
            sx={{
                bgcolor: '#124170',
                color: 'white',
                py: 6,
                mt: 'auto'
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Company Info */}
                    <Grid size={{xs: 12, md: 4}}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Fantasy ultimate champion krew
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 2, color: 'grey.300' }}>
                            Current champion: The Regular Team (Jeff)<br />
                            Current loser: River City Raccoons (Kelin)
                        </Typography>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 4, bgcolor: 'grey.700' }} />

                {/* Bottom Section */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 2
                    }}
                >
                    <Typography variant="body2" color="grey.400">
                        © {currentYear} F.U.C.K. All rights reserved.
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={3}
                        sx={{
                            flexWrap: 'wrap',
                            justifyContent: 'center'
                        }}
                    >
                        <Typography variant="subtitle2">Favicon by <Link underline="none" href="www.freepik.com" rel="nofollow">Freepik</Link></Typography>
                    </Stack>
                </Box>
            </Container>
        </Box>
    )
}

export default Footer
